<script>
  import { onDestroy, onMount } from "svelte";
  import {
    radioCheck,
    isCalculate,
    totalPopulation,
    averageAge,
    LoadingBarValue,
    InsightsRadioCheck,
    bufferZoneValue,
    bufferLocationValue,
    topZonesStore,
    DistanceFromZonesSP,
    ParkingDensitySP,
    levelAccess,
  } from "../store.js";

  import CalculateSchemePotential from "./Params/SP/CalculateSchemePotential.svelte";

  import SpeedDialResults from "./Results/SpeedDialResults.svelte";
  import LoadingBar from "./Results/LoadingBar.svelte";
  import SchemePotential from "./Params/SP/SchemePotential.svelte";

  import OperationZonePotential from "./Params/OZP/OperationZonePotential.svelte";
  import CalculateOperationZonePotential from "./Params/OZP/CalculateOperationZonePotential.svelte";
  import LocationZonePotential from "./Params/LP/LocationZonePotential.svelte";
  import CalculateLocationZonePotential from "./Params/LP/CalculateLocationZonePotential.svelte";
  import ParkingDensityResults from "./Results/ParkingDensityResults.svelte";
  import SchemeResults_SP_OZ from "./Results/SchemeResults_SP_OZ.svelte";
  import SchemeResults_SP_TZ from "./Results/SchemeResults_SP_TZ.svelte";
  import SchemeResults_OZP_OZ from "./Results/SchemeResults_OZP_OZ.svelte";
  import SchemeResults_OZP_TZ from "./Results/SchemeResults_OZP_TZ.svelte";
  import SchemeResults_LP_TZ from "./Results/SchemeResults_LP_TZ.svelte";
  let expanded = false;
  let bufferDrawzones = 5;
  let zones = 2;
  let topZones = 10;
  let walkTime = 15;

  export let map;
  export let Draw;
  function handleOptionChange(event) {
    if (document.getElementsByClassName("mapboxgl-marker").length > 0) {
      [...document.getElementsByClassName("mapboxgl-marker")].forEach((d) => {
        d.remove();
      });
    }
    if (!$isCalculate) {
      document.getElementsByClassName("calcScheme")[0].click();

      $InsightsRadioCheck = event.target.value;
    } else {
      $InsightsRadioCheck = event.target.value;
    }
  }
  function toggleMenu() {
    expanded = !expanded;
  }
</script>

<div class="bottomMenu {expanded ? 'expanded' : ''}">
  <div id="arrow" on:click={toggleMenu} on:keydown={toggleMenu}>
    {#if expanded}
      &#9660; <!-- Downward arrow when expanded -->
    {:else}
      &#9650; <!-- Upward arrow when collapsed -->
    {/if}
  </div>
  {#if $levelAccess == "level2"}
    {#if $isCalculate}
      <div
        style="    position: absolute;
  top: 0px;
  left: 15px;
  margin: 15px;
  font-size: 12px;
  z-index: 100000;"
      >
        <label for="insights"> Choose scheme analysis:</label>
        <select
          id="insights"
          name="insights"
          class="results"
          on:change={handleOptionChange}
        >
          <option value="SP">Preview the operation zone</option>
          <option value="OZP">Draw your own operation zone</option>
          <option value="LP">Single point potential</option>
        </select>
      </div>
      {#if $InsightsRadioCheck == "SP"}
        <div class="schemePotential">
          <SchemePotential {map} />
        </div>
      {/if}
      {#if $InsightsRadioCheck == "OZP"}
        <div class="schemePotential">
          <OperationZonePotential {map} {Draw} />
        </div>
      {/if}
      {#if $InsightsRadioCheck == "LP"}
        <div class="schemePotential">
          <LocationZonePotential {map} {Draw} />
        </div>
      {/if}
    {:else}
      {#if $InsightsRadioCheck == "SP"}
        <div class="schemePotential">
          <h4 style="color:white;margin:15px;font-weight:500">
            Scheme Potential:
          </h4>
          <CalculateSchemePotential {zones} {topZones} {walkTime} {map} />
          <div
            class="slidecontainer"
            style="position:relative;left: 18px;font-size:15px"
          >
            <p>
              Travel zone:
              <span
                style="    text-align: justify;
  right: 30px;
  top: -10px;
  font-weight: 600;
  font-size: 30px;
  color: #45bcbb;
  position: absolute;"
                >{$DistanceFromZonesSP}<span
                  style="font-weight: 400;font-size:16px">km</span
                ></span
              >
            </p>
          </div>
          <div
            class="slidecontainer"
            style="position:relative;left: 18px;font-size:15px"
          >
            <p>
              Parking density: <span
                style="    text-align: justify;
    right: 25px;
    top: -3px;
    font-weight: 600;
    font-size: 20px;
    color: #45bcbb;
    position: absolute;"
                >{$ParkingDensitySP}<span
                  style="font-weight: 400;font-size:16px">m</span
                ></span
              >
            </p>
          </div>
        </div>
      {/if}
      {#if $InsightsRadioCheck == "OZP"}
        <div class="schemePotential">
          <h4 style="color:white;margin:15px;font-weight:500">
            Operation Zone Potential:
          </h4>
          <CalculateOperationZonePotential {topZones} {bufferDrawzones} {map} />
          <div
            class="slidecontainer"
            style="position:relative;left: 18px;font-size:14px"
          >
            <p>
              Travel Zone: <span
                style="    text-align: justify;
  right: 21px;
  top: -4px;
  font-weight: 600;
  font-size: 20px;
  color: #0a6a5b;
  position: absolute;"
                >{$bufferZoneValue}
                <span style="font-weight: 400;font-size:16px">km</span></span
              >
            </p>
          </div>
          <div
            class="slidecontainer"
            style="position:relative;left: 18px;font-size:15px"
          >
            <p>
              Parking density: <span
                style="    text-align: justify;
    right: 25px;
    top: -3px;
    font-weight: 600;
    font-size: 20px;
    color: #0a6a5b;
    position: absolute;"
                >{$ParkingDensitySP}<span
                  style="font-weight: 400;font-size:16px">m</span
                ></span
              >
            </p>
          </div>
        </div>
      {/if}
      {#if $InsightsRadioCheck == "LP"}
        <div class="schemePotential">
          <h4 style="color:white;margin:15px;font-weight:500">
            Location Potential
          </h4>
          <CalculateLocationZonePotential
            {topZones}
            {bufferLocationValue}
            {map}
          />
          <div
            class="slidecontainer"
            style="position:relative;left: 18px;font-size:14px"
          >
            <p>
              Travel Zone: <span
                style="    text-align: justify;
right: 21px;
top: -4px;
font-weight: 600;
font-size: 20px;
color: #D9484D;
position: absolute;"
                >{$bufferLocationValue}
                <span style="font-weight: 400;font-size:16px">km</span></span
              >
            </p>
          </div>
        </div>
      {/if}
    {/if}
    {#if $InsightsRadioCheck == "SP"}
      <div
        style="opacity: {$totalPopulation !== 0 && $LoadingBarValue === 100
          ? 1
          : 0};"
        class="schemeResults"
      >
        <SchemeResults_SP_OZ />
      </div>
      <div
        style="opacity: {$totalPopulation !== 0 && $LoadingBarValue === 100
          ? 1
          : 0};"
        class="schemeResults2"
      >
        <SchemeResults_SP_TZ />
      </div>
    {/if}
    {#if $InsightsRadioCheck == "OZP"}
      <div
        style="opacity: {$totalPopulation !== 0 && $LoadingBarValue === 100
          ? 1
          : 0};"
        class="schemeResults"
      >
        <SchemeResults_OZP_OZ />
      </div>
      <div
        style="opacity: {$totalPopulation !== 0 && $LoadingBarValue === 100
          ? 1
          : 0};"
        class="schemeResults2"
      >
        <SchemeResults_OZP_TZ />
      </div>
    {/if}
    {#if $InsightsRadioCheck == "LP"}
      <div
        style="opacity: {$totalPopulation !== 0 && $LoadingBarValue === 100
          ? 1
          : 0};"
        class="schemeResults"
      >
        <SchemeResults_LP_TZ />
      </div>
    {/if}
    {#if $InsightsRadioCheck == "SP" || $InsightsRadioCheck == "OZP"}
      <div
        style="opacity: {$totalPopulation !== 0 && $LoadingBarValue === 100
          ? 1
          : 0};"
        class="schemeResultsParking"
      >
        <ParkingDensityResults />
      </div>
    {/if}

    <div
      style="opacity: {$averageAge !== 0 && $LoadingBarValue === 100
        ? 1
        : 0};left:{$InsightsRadioCheck == 'SP' || $InsightsRadioCheck == 'OZP'
        ? '990px'
        : '500px'}"
      class="schemeResultsDials"
    >
      <SpeedDialResults />
    </div>
    <div style="opacity: {$LoadingBarValue >= 90 ? 0 : 1};" class="LoadingBar">
      <LoadingBar />
    </div>
  {:else}
    <h1 style="position:relative;color:white;left:20%">
      Upgrade for more features
    </h1>
  {/if}
</div>

<style>
  .schemePotential {
    width: 250px;
    margin: 15px;
    height: 240px;
    position: relative;
    border: 1px solid white;
    border-radius: 10px;
  }
  .schemeResults {
    left: 260px;
    width: 225px;
    margin: 15px;
    height: 240px;
    position: absolute;
    top: 0px;
    border: 1px solid white;
    border-radius: 10px;
    transition: opacity 1s ease; /* Smooth transition */
  }
  .schemeResults2 {
    left: 500px;
    width: 225px;
    margin: 15px;
    height: 240px;
    position: absolute;
    top: 0px;
    border: 1px solid white;
    border-radius: 10px;
    transition: opacity 1s ease; /* Smooth transition */
  }
  .schemeResultsParking {
    left: 750px;
    width: 225px;
    margin: 15px;
    height: 240px;
    position: absolute;
    top: 0px;
    border: 1px solid white;
    border-radius: 10px;
    transition: opacity 1s ease; /* Smooth transition */
  }
  .schemeResultsDials {
    width: 645px;

    margin: 15px;
    height: 240px;
    position: absolute;
    top: 0px;
    border: 1px solid white;
    border-radius: 10px;
    transition: opacity 1s ease; /* Smooth transition */
  }
  .LoadingBar {
    left: 500px;
    width: 60%;
    margin: 15px;
    height: 240px;
    position: absolute;
    top: 0px;

    border-radius: 10px;
    transition: opacity 1s ease; /* Smooth transition */
  }

  .bottomMenu {
    overflow-x: auto;
    overflow-y: hidden;
    opacity: 90%;
    height: 15px;
    width: 1670px;
    bottom: 0px;
    position: absolute;
    z-index: 10000;
    background-color: black;
    border-radius: 5px;

    color: white;
    transition: height 1s ease; /* Smooth transition */
  }
  @media (max-width: 1670px) {
    .bottomMenu {
      width: 100%;
    }
  }

  .bottomMenu.expanded {
    height: 270px; /* Expanded height */
  }

  #arrow {
    position: absolute;
    top: -7px; /* Position the arrow above the menu */
    left: 50%;
    transform: translateX(-50%);
    width: 30px;
    height: 30px;
    z-index: 100000;
    background-color: black;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: white;
    font-size: 15px;
  }
  .slidecontainer {
    width: 100%;
  }
</style>
